import { CardEntryMethod, IntegrationSystem, LoyaltyAuthEntryMethod, LoyaltyAuthMethod, allEnumValues } from "@biteinc/enums";
import { z } from "zod/v3";
//#region src/public_types/auth_and_reward_data.ts
const starbucksUserMetadataSchema = z.object({
	type: z.union([z.literal("rewards-account"), z.literal("gift-card")]),
	integrationSystem: z.literal(IntegrationSystem.StarbucksFullLoyalty),
	scrimImageUrl: z.string().optional(),
	loyaltyIconUrl: z.string().optional(),
	rewardCelebrationUrl: z.string().optional(),
	pointBalance: z.number().optional(),
	currentLevelName: z.string().optional(),
	pointsToNextLevel: z.number().nullable().optional(),
	pointsToMaintainLevel: z.number().nullable().optional(),
	annualEarnedStars: z.number().optional(),
	anniversaryDate: z.string().optional(),
	memberSinceBadgeUrl: z.string().optional(),
	starExpiryDate: z.string().optional(),
	expiringStars: z.number().optional()
});
const loyaltyUserMetadataSchema = starbucksUserMetadataSchema;
const authSchema = z.object({
	authToken: z.string().optional(),
	tokenData: z.string().optional(),
	redemptionCode: z.string().optional(),
	otpToken: z.string().optional(),
	customerId: z.string().optional(),
	firstName: z.string().optional(),
	lastName: z.string().optional(),
	loyaltyDirectAuthToken: z.object({ tokenData: z.string() }).optional(),
	loyaltyCardId: z.string().optional(),
	metadata: loyaltyUserMetadataSchema.optional(),
	tokenDataEntryMethod: z.enum(allEnumValues(LoyaltyAuthEntryMethod)).optional(),
	authEntryMethod: z.enum(allEnumValues(LoyaltyAuthEntryMethod)).optional(),
	redemptionCodeEntryMethod: z.enum(allEnumValues(LoyaltyAuthEntryMethod)).optional()
});
const extendedAuthDataSchema = z.discriminatedUnion("method", [
	z.object({
		...authSchema.shape,
		method: z.literal(LoyaltyAuthMethod.Barcode)
	}),
	z.object({
		...authSchema.shape,
		method: z.literal(LoyaltyAuthMethod.Hid)
	}),
	z.object({
		...authSchema.shape,
		method: z.literal(LoyaltyAuthMethod.CardNumber)
	}),
	z.object({
		...authSchema.shape,
		email: z.string(),
		method: z.literal(LoyaltyAuthMethod.Email)
	}),
	z.object({
		...authSchema.shape,
		email: z.string(),
		password: z.string(),
		method: z.literal(LoyaltyAuthMethod.EmailPassword)
	}),
	z.object({
		...authSchema.shape,
		method: z.literal(LoyaltyAuthMethod.EmailPhoneNumber),
		email: z.string(),
		phone: z.string()
	}),
	z.object({
		...authSchema.shape,
		phone: z.string(),
		method: z.literal(LoyaltyAuthMethod.PhoneNumber)
	}),
	z.object({
		...authSchema.shape,
		password: z.string(),
		username: z.string(),
		method: z.literal(LoyaltyAuthMethod.UsernamePassword)
	}),
	z.object({
		...authSchema.shape,
		method: z.literal(LoyaltyAuthMethod.WebSessionToken)
	}),
	z.object({
		...authSchema.shape,
		method: z.literal(LoyaltyAuthMethod.ManualRedemption)
	})
]);
const quickchargeDiscountSchema = z.object({
	id: z.number(),
	discountTypeId: z.number(),
	name: z.string(),
	discountType: z.string(),
	amount: z.number(),
	percentCapDollarAmount: z.number().nullable(),
	startTime: z.string(),
	endTime: z.string(),
	singleUse: z.boolean()
});
const storedValueAuthDataSchema = z.object({
	cardNumber: z.string().optional(),
	giftCardPin: z.string().optional(),
	cardEntryMethod: z.nativeEnum(CardEntryMethod).optional(),
	sessionToken: z.string().optional(),
	terminalId: z.string().optional(),
	terminalNumber: z.string().optional(),
	posOrderId: z.string().optional(),
	accountTender: z.string().optional(),
	accountType: z.number().optional(),
	isTaxExempt: z.boolean().optional(),
	tenderName: z.string().optional(),
	accountId: z.number().optional(),
	qcDiscountsAvailable: z.array(quickchargeDiscountSchema).optional()
});
//#endregion
export { authSchema, extendedAuthDataSchema, loyaltyUserMetadataSchema, starbucksUserMetadataSchema, storedValueAuthDataSchema };

//# sourceMappingURL=auth_and_reward_data.js.map